import logo from "./logo.svg";
import "./App.css";
import { Home, Login, NewTask, TaskDetails } from "./pages";
import { FrappeProvider } from "frappe-react-sdk";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useRoutes,
} from "react-router-dom";
import config from "./config";
import Loader from "./Components/Loader";
import { Toaster } from "react-hot-toast";
import useAuthStore from "./store/authstore";
import { FrappeApp, getTokenFromLocalStorage } from "frappe-js-sdk";
import FrappeLogin from "./pages/FrappeLogin";
import { routes } from "./routes";
import { AuthProvider } from "react-oauth2-code-pkce";
import MainComponent from "./Components/MainComponent";

function RouteLayout({ path }) {
  const element = useRoutes(path);
  return element;
}
const createAuthConfig = (baseUrl, clientId) => {
  if (clientId && baseUrl) {
    return {
      clientId: clientId,
      authorizationEndpoint: `${baseUrl}/api/method/frappe.integrations.oauth2.authorize`,
      tokenEndpoint: `${baseUrl}/api/method/frappe.integrations.oauth2.get_token`,
      redirectUri: window.location.origin + "/", // ✅ Must match Frappe OAuth Client exactly
      scope: "openid all offline_access", // ✅ Array + offline_access for refresh_token
      decodeToken: false,
      autoRefresh: true, // ✅ Auto-refresh before expiry
      refreshTokenExpiryStrategy: "renewable", // ✅ Keep session alive with activity
      logoutEndpoint: `${baseUrl}/logout`, // Optional: Endpoint to log out from the provider

      // onRefreshTokenExpire: (event) =>
      // event.logIn(undefined, undefined, "popup"),

      // tokenExpiresIn: 36000000,
      // refreshTokenExpiresIn: 36000000,
      onTokenRefresh: (newToken) => {
        // ✅ Sync refreshed token to your Zustand store
        useAuthStore.getState().setToken(newToken);
      },
      autoLogin: true,
    };
  }
  return null;
};
function App() {
  const token = useAuthStore((state) => state.token);
  const baseUrl = useAuthStore((state) => state.baseUrl);
  const authConfig = createAuthConfig(config.API_BASE_URL, config.CLIENT_ID);
  const logout = useAuthStore((state) => state.logout);

  return (
    <>
      <Toaster />
      {authConfig ? (
        <AuthProvider key={baseUrl} authConfig={authConfig}>
          <MainComponent />
        </AuthProvider>
      ) : (
        <Loader />
      )}
    </>
  );
}

export default App;
